import { useSelector } from "react-redux";
import { getQueryValue } from "../../../../../store/selectors";
import { PDLTypography } from "../../../dna";
import FilterCarouselContent from "../../../global/_filterCarouselContent";

const SemResultados = ({ tipo = "" }) => {
  const query = useSelector(getQueryValue);

  return (
    <div className="pdl_components_lista_resultados_bloco mt-5">
      <FilterCarouselContent tipo={tipo} />

      <PDLTypography size="md" weight="bold" className="mt-5">
        0 resultados encontrados para {query}. Tente outra busca.
      </PDLTypography>
      <PDLTypography size="md" className="mt-3">
        Sugestões
      </PDLTypography>
      <div className="mt-3">
        <ul>
          <li>
            <PDLTypography size="md">
              Verifique se há erros de ortografia
            </PDLTypography>
          </li>
          <li>
            <PDLTypography size="md">
              Use palavras alternativas para descrever o que você está
              procurando
            </PDLTypography>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default SemResultados;
